import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import classnames from "classnames";
import {faIcons} from "../../utils/iconConstants";

const ConfirmationModal = ({
                               children,
                               cancellationCallback,
                               confirmationCallback,
                               modalClassName = "Modal",
                               modalHeaderClassName = "modal-header",
                               headerText,
                               submitButtonDisabled = false,
                               confirmButtonText,
                               confirmButtonClass,
                               loading = false,
                               showExitButton = true
                           }) => {
    return (
        <Modal
            clickable
            isOpen={true}
            className={modalClassName}
            overlayClassName="Overlay"
            ariaHideApp={false}
            onRequestClose={loading ? undefined : cancellationCallback}
            testId={"confirmation-modal"}
        >
            <div className={modalHeaderClassName}>
                <div><h5 className={"modal-header-text"}>{headerText}</h5></div>
                {showExitButton && <div data-testid={'confirmation-modal-exit-button'}>
                    <button className={"right-exit-button"} onClick={cancellationCallback} disabled={loading}>
                        <i data-testid={'x-icon'} className={faIcons.xClose} /></button>
                </div>}
            </div>
            <div>{children}</div>
            <div className={"right-things"}>
                <button className="button modal-button cancel" type="button" name="close"
                        onClick={cancellationCallback}
                        disabled={loading}
                >
                    Cancel
                </button>
                <button type="button"
                        className={classnames("button", "modal-button", "confirm", confirmButtonClass)}
                        onClick={confirmationCallback}
                        disabled={submitButtonDisabled || loading}
                >
                    {loading && <i className={`${faIcons.spinner} fa-spin`} data-testid={"spinner"}/>}
                    {confirmButtonText || "Confirm"}
                </button>
            </div>
        </Modal>
    );
};

ConfirmationModal.propTypes = {
    cancellationCallback: PropTypes.func.isRequired,
    confirmationCallback: PropTypes.func.isRequired,
    modalHeaderClassName: PropTypes.string,
    modalClassName: PropTypes.string,
    headerText: PropTypes.string,
    submitButtonDisabled: PropTypes.bool,
    loading: PropTypes.bool,
    showExitButton: PropTypes.bool
};

export default ConfirmationModal;